'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CheckIcon = ({ sx, showCheck = true }) => {
  return (
    <SvgIcon sx={sx} data-testid="CheckIcon">
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_69_817)">
          {showCheck ? (
            <path
              d="M24.75 9.625L15.9775 21.5325C15.8671 21.6828 15.7273 21.8091 15.5665 21.9036C15.4058 21.9982 15.2275 22.059 15.0425 22.0825C14.86 22.1058 14.6747 22.0922 14.4976 22.0426C14.3205 21.9931 14.1551 21.9084 14.0112 21.7938L8.25 17.1875"
              stroke={sx?.color || '#3D517B'}
              strokeOpacity={sx?.opacity || '0.56'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          ) : null}

          <path
            d="M0.6875 16.5C0.6875 18.5765 1.0965 20.6327 1.89115 22.5512C2.68581 24.4696 3.85055 26.2128 5.31887 27.6811C6.7872 29.1495 8.53036 30.3142 10.4488 31.1088C12.3673 31.9035 14.4235 32.3125 16.5 32.3125C18.5765 32.3125 20.6327 31.9035 22.5512 31.1088C24.4696 30.3142 26.2128 29.1495 27.6811 27.6811C29.1495 26.2128 30.3142 24.4696 31.1088 22.5512C31.9035 20.6327 32.3125 18.5765 32.3125 16.5C32.3125 14.4235 31.9035 12.3673 31.1088 10.4488C30.3142 8.53036 29.1495 6.7872 27.6811 5.31887C26.2128 3.85055 24.4696 2.68581 22.5512 1.89115C20.6327 1.0965 18.5765 0.6875 16.5 0.6875C14.4235 0.6875 12.3673 1.0965 10.4488 1.89115C8.53036 2.68581 6.7872 3.85055 5.31887 5.31887C3.85055 6.7872 2.68581 8.53036 1.89115 10.4488C1.0965 12.3673 0.6875 14.4235 0.6875 16.5Z"
            stroke={sx?.color || '#3D517B'}
            strokeOpacity={sx?.opacity || '0.56'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

CheckIcon.propTypes = {
  sx: PropTypes.object,
  showCheck: PropTypes.bool
}
